import React, { useEffect, useRef } from 'react';
import { BellRing } from 'lucide-react';

const ago = (iso) => {
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  return m < 60 ? `${m}m ago` : `${Math.floor(m / 60)}h ${m % 60}m ago`;
};

export const NotificationRail = ({ notifications, selectedId, onTrade }) => {
  const refs = useRef({});
  useEffect(() => {
    if (selectedId && refs.current[selectedId]) refs.current[selectedId].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }, [selectedId, notifications.length]);

  return (
    <section data-testid="notification-rail">
      <div className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">
        <BellRing size={14} className="text-sky-400" /> Today's notifications
      </div>
      {notifications.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="notification-rail-empty">No notifications yet today. New ones appear here instantly.</p>
      ) : (
        <div className="sim-rail flex gap-3 overflow-x-auto pb-2">
          {notifications.map((n) => {
            const active = n.id === selectedId;
            return (
              <div key={n.id} ref={(el) => { refs.current[n.id] = el; }} className={`sim-notif ${active ? 'sim-notif-active' : ''}`} data-testid={`notif-card-${n.id}`}>
                <div className="flex items-center justify-between gap-3">
                  <span className="truncate text-xs text-slate-400" data-testid={`notif-time-${n.id}`}>{n.skull && <span data-testid={`notif-skull-${n.id}`} title="Bad conditions">💀 </span>}{n.mt5_date} · MT5 {n.mt5_time}</span>
                  <span className="shrink-0 text-[11px] text-slate-500">{ago(n.created_at)}</span>
                </div>
                <div className="mt-2 flex items-center justify-between gap-3">
                  <div>
                    <div className="font-semibold text-white">{n.pair}</div>
                    <div className={`text-xs font-bold ${n.direction === 'BUY' ? 'text-emerald-400' : 'text-rose-400'}`}>{n.direction}</div>
                  </div>
                  <button type="button" onClick={() => onTrade(n)} className="sim-trade-btn" data-testid={`notif-trade-btn-${n.id}`}>
                    {active ? 'ON CHART' : n.trade_open ? 'VIEW TRADE' : 'TRADE'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};
